import React from "react";
import { Link } from "react-router-dom";
import { Infinity as InfinityIcon, LogOut } from "lucide-react";
import { ProjectFilter } from "@/components/shell/ProjectFilter";
import { LastSynced } from "@/components/shell/LastSynced";

const HOVER_TRANSITION = { transition: "color .2s ease, border-color .2s ease" };

export function TopBar({ user, onLogout }) {
  return (
    <header className="sticky top-0 z-30 border-b border-[#E5E7EB] bg-white">
      <div className="flex items-center justify-between px-6 md:px-10 py-4">
        <div className="md:hidden flex items-center gap-2">
          <InfinityIcon className="h-5 w-5 text-[#156F5B]" strokeWidth={2.5} />
          <Link to="/dashboard" className="text-lg font-bold font-heading text-[#156F5B]">KOIOC</Link>
        </div>
        <div className="hidden md:block k-label">Empowering your buildings with data driven insights</div>
        <div className="flex items-center gap-4 flex-wrap justify-end">
          <ProjectFilter />
          <LastSynced />
          <div className="flex items-center gap-3 pl-4 border-l border-[#E5E7EB]">
            <div className="hidden sm:block text-right leading-tight">
              <div className="text-xs font-heading font-semibold text-[#212121] truncate max-w-[160px]" data-testid="header-user-name">
                {user?.name}
              </div>
              <div className="text-[10px] font-heading font-semibold uppercase tracking-wider text-[#156F5B]">
                {user?.role}
              </div>
            </div>
            <button
              data-testid="logout-btn"
              onClick={onLogout}
              title={`Sign out ${user?.email || ""}`}
              className="flex items-center gap-1.5 rounded-md border border-[#E5E7EB] bg-white px-3 py-1.5 text-xs font-heading font-semibold text-[#4D4D4D] hover:border-red-300 hover:text-red-600"
              style={HOVER_TRANSITION}
            >
              <LogOut className="h-3.5 w-3.5" />
              <span className="hidden sm:inline">Sign out</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
